<template>
  <el-row>
    <el-col :span="24">
      <el-input :class="errors.has(item.id) ? 'is-error':''" type="textarea" v-validate="item.isRequired ? 'required' :''" :name="item.id" ref="textarea" :autosize="{ minRows: 4, maxRows: 6}" :placeholder="item.body.placeholder" v-model="value">
      </el-input>
    </el-col>
  </el-row>
</template>
<script>
export default {
  data() {
    return {
      value: ''
    }
  },
  inject: ['parentValidator'],
  methods: {
    sendDataSurvey(data) {
      var _this = this
      _this.$store.commit('editSurvey', data)
    }
  },
  watch: {
    value: function(val) {
      var _this = this
      _this.sendDataSurvey({ surveyDetailId: _this.item.id, values: [_this.value] })
    }
  },
  created() {
    var _this = this
    this.$validator = this.parentValidator
  },
  props: ['item']
}
</script>

